(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["view-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const select = document.querySelector('.view-controls__select');
    if (select instanceof HTMLSelectElement) {
      select.value = localStorage.getItem('productView') === 'grid' ? 'grid' : 'list';

      select.addEventListener('change', (e) => {
        const value = e.target.value;
        localStorage.setItem('productView', value);
        e.target.closest('.shopify-section')?.classList.toggle('is-grid-view', value === 'grid');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
